 <template>

   <!--底部导航栏-->
   <div class="box fixed-nav">
     <div @click = "gotoUrl('/')" class="flex fixed-nav-tab fixed-nav-tab01" :class="style">
       <span></span>
       <p>首页</p>
     </div>
     <!--<div @click = "gotoUrl({path: 'video-play', query: {lastid:'2', lastshopid:'', lastspotid:'', buystate: 1, trytime:0 }})" class="flex fixed-nav-tab fixed-nav-tab02"  style="display: none;">-->
       <!--<div class="border-box">-->
         <!--<img class="fixed-nav-bj" src="../assets/icon_main_play01.png" alt="">-->
         <!--<span class="fixed-nav-btn" v-bind:class="{curr: playState}"></span>-->
       <!--</div>-->
     <!--</div>-->
     <!--<div @click = "gotoUrl('/map')" class="flex fixed-nav-tab fixed-nav-tab04" :class="style" v-if="siteid==''&&sregion==''">-->
       <!--<span></span>-->
       <!--<p>地图</p>-->
     <!--</div>-->
     <!--<div @click = "gotoUrl('/study-activity')" class="flex fixed-nav-tab fixed-nav-tab05" :class="style" v-if="siteid==31 || siteid==''&&sregion==''">-->
       <!--<span></span>-->
       <!--<p>研学</p>-->
     <!--</div>-->
     <div @click="gotoUrl('/video-vrlist')" class="flex fixed-nav-tab fixed-nav-tab06" :class="style">
       <span></span>
       <p>VR视频</p>
     </div>
     <div @click="gotoUrl('/user')" class="flex fixed-nav-tab fixed-nav-tab03" :class="style">
       <span></span>
       <p>我的</p>
     </div>
   </div>

</template>

<script>

import { mapState } from 'vuex'
import {setStore, getStore, removeStore} from '@/config/mUtils'

export default {
    data(){
        return{
          playState: false,
          lastMyVoice: {
            lasturl: '', //音频链接
            lasttitle: '', //音频标题
            lastspotid: '', //景点id
            lastguideimg: '', //导游头像
            lastid: '', //专辑id
            lastshopid: '' //景区id
          }, //记录我最后一次听的音频信息
        }
    },
    created(){
    },
    props: ['siteid','sregion','appKeyA','citycode'],
    mounted(){

    },
    computed: {
      style() {
        var path = this.$route.path;
        var cla = 'curr1'
        if (path == '/user'){
          cla = 'curr3';
        }else if(path == '/study-activity'){
          cla = 'curr5';
        }else if(path == '/map') {
          cla = 'curr4';
        }
        return cla
      },
    },
    methods: {
      gotoUrl(path){
        if(path == '/'){
          MtaH5.clickStat("foot_js");
        }else if(path == '/user'){
          MtaH5.clickStat("foot_user");
        }else if(path == '/study-activity'){
          MtaH5.clickStat("foot_study");
        }else if(path == '/map'){
          MtaH5.clickStat("foot_map");
        }
        this.$router.push({path:path, query:{citycode:this.citycode || '1',siteid:this.siteid,appKey:this.appKeyA}})
      },

      /**
       * 初始化当前底部导航栏播放按钮状态
       */
      innitPlayBtn() {

      },

      /**
       * 跳转到专辑详情页面（点底部播放按钮）
       */
      toVideoPlay() {


      },

    }
}
</script>


<style scoped>

  /*首页底部nav*/
  .fixed-nav{ position:fixed; left: 0; right: 0; bottom: 0; z-index: 10; width:100vw; height: .96rem; background:#fff; padding-bottom: env(safe-area-inset-bottom)}
  .fixed-nav-tab{ position: relative; display: block; height: .96rem; }
  .fixed-nav-tab02{ width: 34%;}
  .fixed-nav-tab > span{display:block; width: .52rem; height: .52rem; margin: .12rem auto 0; }
  .fixed-nav-tab01 span{ background: url(../assets/new-index/nav-sy.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab03 span{ background: url(../assets/new-index/nav-wd.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab04 span{ background: url(../assets/icon_26.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab05 span{ background: url(../assets/icon_27.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab06 span{ background: url(../assets/new-index/nav-vr.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab01.curr1 span{ background: url(../assets/new-index/nav-sy-curr.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab03.curr3 span{ background: url(../assets/new-index/nav-wd-curr.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab04.curr4 span{ background: url(../assets/icon_26_curr.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab05.curr5 span{ background: url(../assets/icon_27_curr.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab p{ display:block; margin-top: .01rem; font-size: .2rem; line-height: .28rem; text-align: center; color: #333; }
  .fixed-nav-tab01.curr1 p{ color: #030201; }
  .fixed-nav-tab03.curr3 p{ color: #030201; }
  .fixed-nav-tab04.curr4 p{ color: #faaf39; }
  .fixed-nav-tab05.curr5 p{ color: #faaf39; }
  .fixed-nav-tab02 > div{ position: absolute; left: 50%; top: -.29rem; z-index: 1; width: 1.26rem; height: 1.26rem; padding: .09rem; margin-left: -.63rem; background-color: #fff; border-radius: 50%; }
  .fixed-nav-bj{ width: 1.09rem; height: 1.09rem; border-radius: 50%; }
  .fixed-nav-btn{ position: absolute; left: .44rem; top: .44rem; z-index: 1; width: .39rem; height: .39rem; background: url(../assets/icon_main_play02.png) no-repeat center; background-size: 100% 100%; }
  .fixed-nav-tab02.curr .fixed-nav-btn{ background: url(../assets/icon_main_play03.png) no-repeat center; background-size: 100% 100%; }

</style>



// WEBPACK FOOTER //
// src/components/Foot.vue